import { render, staticRenderFns } from "./TopMenuList.vue?vue&type=template&id=0f66f862&scoped=true&"
import script from "./TopMenuList.vue?vue&type=script&lang=js&"
export * from "./TopMenuList.vue?vue&type=script&lang=js&"
import style0 from "./TopMenuList.vue?vue&type=style&index=0&id=0f66f862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66f862",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VIcon})
